import React from 'react';
import ReactDOM from 'react-dom/client';
import './root.css'
import RouteUrls from './RouteUrls';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouteUrls />
  </React.StrictMode>
);
